export const SET_FEEDBACK = 'SET_FEEDBACK'
export const REMOVE_FEEDBACK = 'REMOVE_FEEDBACK'

export const SET_HEADER_BACK = 'SET_HEADER_BACK'
export const REMOVE_HEADER_BACK = 'REMOVE_HEADER_BACK'

export const SET_MENU_TOGGLE = 'SET_MENU_TOGGLE'

export const UPDATE_USERNAME = 'UPDATE_USERNAME'
